import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import './CRUDSensors.css';
import { Server_URL } from "../config.js";

function CRUDSensors() {
  // const [data, setData] = useState([])
  const [sensors, setSensors] = useState([]);
  const [deleted, setDeleted] = useState(true)
  // const { id } = useParams();
  // const navigate = useNavigate();
  const [keyin, setKeyin] = useState([]);

  // console.log('get into CRUDSensors()');
  useEffect(() => {
    if (deleted) {
      setDeleted(false)
      axios
        .get(`${Server_URL}/show_sensors`)
        // .get('http://localhost:3022/show_sensors')
        // .get('http://localhost:5000/show_sensors')
        // .then((res) => { setSensors(res.data); console.log(sensors); })
        .then((res) => { setSensors(res.data) })
        .catch((err) => console.log(err))
    }
  }, [deleted])

  function handleDelete(id) {
    axios
      .delete(`${Server_URL}/delete_sensor/${id}`)
      // .delete(`http://localhost:3022/delete_sensor/${id}`)
      // .delete(`http://localhost:5000/delete_sensor/${id}`)
      .then((res) => { setDeleted(true) })
      .catch((err) => console.log(err))
  }

  return (
    // <div className='container-fluid bg-primary vh-100 vw-100'>
    <div className='container-fluid vh-100 vw-100'>
      <div> <h2 className='text-center'>Sensor List</h2> </div>
      <div> <h1 className='crudsensor'> </h1> </div>
      <div className='d-flex justify-content-start'>
        <Link to='/CreateSensor' className='btn btn-success mx-2'>Add Sensor</Link>
        <input type="text20" placeholder="Size..." value={keyin} onChange={(e) => setKeyin(e.target.value)} required />
        <Link to={`/CRUDSensorsBySize/${keyin}`} className='btn btn-success mx-2'>Select Sensor Size</Link>
        {/* <button className='btn btn-success' onClick={() => navigate(`/ListingSensorsBySize/${keyin}`)}>Touch Size</button> */}
      </div>
      <br />
      <h3 className='text-center'>Sensor All</h3>
      {/* <table className='table table-bordered'> */}
      {/* <table className='table'> */}
      <table>
        <thead className='m-1 px-1 fs-6 text-center bg-success-subtle'>
          <tr>
            <th>-SNo-</th> <th>-Size-</th> <th>-PartNo-</th> <th>-Ratio-</th>
            <th>-SensorOD-</th> <th>-SensorAA-</th> <th>-SGThick-</th>
            <th>-CoverVA-</th>
            <th>-ChnRxTx-</th> <th>-Control/IC-</th>
            {/* <th>FPCLocation，</th> <th>ScreenPartNo，</th> <th>CustomerPartNo，</th> */}
            <th>-Note-</th> <th>-DrawYes-</th>
            <th>-Actions-</th>
          </tr>
        </thead>

        <tbody className='m-1 px-1 fs-6 text-center bg-primary-subtle'> {
          sensors.map((sensor, i) => {
            // console.log(" sensor.SNo :", sensor.SNo, " sensor.PartNo :", sensor.PartNo);
            return (
              <tr key={i++}>
                <td>{sensor.SNo}</td> <td>{sensor.Size}</td> <td>{sensor.PartNo}</td> <td>{sensor.Ratio}</td>
                <td>{sensor.SensorOD}</td> <td>{sensor.SensorAA}</td> <td>{sensor.SensorThick}</td>
                <td>{sensor.CoverVA}</td>
                <td>{sensor.ControlCard}</td> <td>{sensor.ChannelRxTx}</td>
                {/* <td>{sensor.FpcLoc}</td> <td>{sensor.PrintPN}</td> <td>{sensor.CustomerPN}</td> */}
                <td>{sensor.Note}</td> <td>{sensor.DrawYes}</td>
                <td>
                  <Link to={`/ShowSensorDetail/${sensor.SNo}`} className='btn trbtn-success m-1 px-2 py-1'>Read</Link>
                  <Link to={`/EditSensor/${sensor.SNo}`} className='btn trbtn-success m-1 px-2 py-1'>Edit</Link>
                  <button onClick={() => handleDelete(sensor.SNo)} className='btn trbtn-danger m-1 px-2 py-1'>
                    Delete
                  </button>
                </td>
              </tr>
            )
          })
        } </tbody>
      </table>
    </div>
  )
}

export default CRUDSensors